export default __webpack_public_path__ + "static/media/cz_light.6b287ebc.png";